import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { LocaleService } from "../../shared/i18n/locale.service";
import { TranslatePipe } from "../../shared/i18n/translate.pipe";
@Component({
  selector: "app-consent-information",
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: "./consent-information.component.html",
  styleUrl: "./consent-information.component.scss",
})
export class ConsentInformationComponent {
  constructor(private localeService: LocaleService) {}

  get subList(): string[] {
    return this.localeService.tArray("consent.items");
  }
}
